module.exports = __webpack_public_path__ + "static/bkg-label-sheep-v2-775f8fb21c72710d067150ec8ea971a3.png";